module.exports = __webpack_public_path__ + "static/media/star.be78177c.svg";